import React, { useMemo } from 'react';
import { MessageBox } from 'components';
import { WORKBOARD_CURRENT_VALUATIONS_URL } from 'dashboard409a/common/config/urls';
import { EmptyOperationsMessageProps } from './EmptyOperationsMessage.props';
import GoToWorkboard from './GoToWorkboard';

const EmptyOperationsMessage = ({ title, tagline, secondaryAction }: EmptyOperationsMessageProps) => {

  const workboardURL = useMemo(() => WORKBOARD_CURRENT_VALUATIONS_URL, []);

  return (
    <MessageBox
      title={title || 'Valuation not Selected'}
      tagline={tagline || 'Please select a valid valuation on Workboard section'}
      fullWidth={false}
      action={<GoToWorkboard workboardURL={workboardURL} />}
      secondaryAction={secondaryAction}
    />
  );
};

export default EmptyOperationsMessage;
